import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { DashboardEntity } from './dashboard.entity';

@Index('idx_default_dashboard', ['fkDashboardId'], {})
@Index('idx_user', ['userId'], {})
@Index('userId', ['userId'], { unique: true })
@Entity('user_dashboard_preferences')
export class UserDashboardPreferencesEntity extends BaseEntity {
	@Column('int', { name: 'userId', unique: true, unsigned: true })
	public userId!: number;

	@Column('int', { name: '_fk__dashboard__id', nullable: true, unsigned: true })
	public fkDashboardId!: number | null;

	@Column('tinyint', {
		name: 'autoRefresh',
		nullable: true,
		width: 1,
		default: () => "'1'",
	})
	public autoRefresh!: boolean | null;

	@Column('int', {
		name: 'defaultRefreshInterval',
		nullable: true,
		unsigned: true,
		default: () => "'300000'",
	})
	public defaultRefreshInterval!: number | null;

	@Column('int', {
		name: 'gridColumns',
		nullable: true,
		unsigned: true,
		default: () => "'4'",
	})
	public gridColumns!: number | null;

	@Column('varchar', {
		name: 'theme',
		nullable: true,
		length: 50,
		default: () => "'default'",
	})
	public theme!: string | null;

	@Column('varchar', {
		name: 'language',
		nullable: true,
		length: 10,
	})
	public language!: string | null;

	@Column('json', { name: 'preferences', nullable: true })
	public preferences!: object | null;

	@ManyToOne(
		() => DashboardEntity,
		(dashboard) => dashboard.userDashboardPreferences,
		{ onDelete: 'SET NULL', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([{ name: '_fk__dashboard__id', referencedColumnName: 'id' }])
	public fkDashboard!: DashboardEntity;
}
